export default __webpack_public_path__ + "static/media/search.33003b1e.svg";